import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import NotFound from "pages/NotFound";
import Login from "pages/Login";
import Dashboard from "pages/Dashboard";
import RecordDetail from "pages/RecordDetail";
import WebpageNotarization from './pages/webpage-notarization';
import ArchiveDetails from './pages/archive-details';
import WalletConnection from './pages/wallet-connection';
import Settings from './pages/settings';
import TransactionHistory from './pages/transaction-history';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected routes */}
        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/records/:id" element={<ProtectedRoute><RecordDetail /></ProtectedRoute>} />
        <Route path="/webpage-notarization" element={<ProtectedRoute><WebpageNotarization /></ProtectedRoute>} />
        <Route path="/archive-details" element={<ProtectedRoute><ArchiveDetails /></ProtectedRoute>} />
        <Route path="/wallet-connection" element={<ProtectedRoute><WalletConnection /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/transaction-history" element={<ProtectedRoute><TransactionHistory /></ProtectedRoute>} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;